module.exports = __webpack_public_path__ + "static/StaffHero-4fe8c29c5993d645f5ae66e226512978.jpg";